const homepage_tour = {
	steps: {
		company: {
			description: "Hier können Sie die Daten Ihres Unternehmens einsehen und bearbeiten.",
			title: "Unternehmen",
		},
		firstview: {
			description:
				"Sie können eine kurze Tour starten (etwa 1 Minute), damit Sie wissen, was das Portal kann und wo Sie Daten und Produkte finden.",
			title: "Willkommen auf dem Tuxis-Portal",
		},

		homepage: {
			description:
				"Hier haben Sie einen Überblick über die erworbenen Dienstleistungen. Wenn Sie zu dieser Homepage zurückkehren möchten, klicken Sie auf das Tuxis-Logo oben in der linken Seitenleiste.",
			title: "Homepage",
		},

		personal: {
			business: {
				description:
					"Hier finden Sie Einstellungen und Details für Ihr persönliches Konto, einschließlich Ihres Passwortspeichers, SSH-Schlüssel, E-Mail-Adressen für Benachrichtigungen und Zwei-Faktor-Authentifizierung (2FA).\nFunktionale Elemente wie die Änderung des Passworts und die Einstellung der Kommunikationssprache finden Sie ebenfalls hier.",
			},
			private: {
				description:
					"Hier finden Sie Einstellungen und Details für Ihr persönliches Konto, einschließlich Ihres Passwortspeichers, SSH-Schlüssel, E-Mail-Adressen für Benachrichtigungen und Zwei-Faktor-Authentifizierung (2FA).\nFunktionale Elemente wie die Änderung des Passworts und die Einstellung der Kommunikationssprache finden Sie ebenfalls hier.",
			},
			title: "Persönlich",
		},

		products_and_services: {
			description:
				"Hier verwalten Sie Produkte und Dienstleistungen. Hier können Sie neue Produkte und Dienstleistungen anlegen oder bestellen, bearbeiten und kündigen.",
			title: "Produkte und Dienstleistungen",
		},

		relations: {
			description:
				"Beziehungen ermöglichen es Ihnen, Produkte und Dienstleistungen mit einer Person, einem Unternehmen oder einer Abteilung zu verknüpfen. So können Sie nachverfolgen, welche Produkte Sie für wen erstellt haben.",
			title: "Beziehungen",
		},

		shortcuts: {
			description:
				"Hier finden Sie Verknüpfungen, um zwischen hellen und dunklen Themen zu wechseln, sich abzumelden, gemeinsame Passwörter zu verwalten und Probleme zu melden.",
			title: "Abkürzungen",
		},

		username: {
			description:
				"Sie können eine kurze Tour starten (etwa 1 Minute), damit Sie wissen, was das Portal kann und wo Sie Daten und Produkte finden.",
			title: "Benutzername",
		},
	},
};

export default homepage_tour;
